import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { inject, runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { AuthserviceService } from '../../content/pages-new-design/auth-page/login-page/authservice.service';
import { HeaderClientService } from '../../services/client/header-service/header-client.service';
import { IdentityRequestService } from '../../services/request/identity-request.service';
import { TakenOverIdentity } from '../../models/rights/identity/taken-over-identity.model';

export class SseAccessKeyEvent extends SseEventBase {

  type: SseEventType = 'accessKey';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.ACCESS_KEY_EXPIRED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.accessKeyExpired());
          inject(AuthserviceService).logout();
          window.sessionStorage.clear();
          setTimeout(() => this.router.navigate(['/']), 200);
          break;
        }
        case NotificationReasonEnum.TAKEN_OVER_ACCESS_KEY_EXPIRED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.takenOverAccessKeyExpired());
          const headerClientService: HeaderClientService = inject(HeaderClientService);
          inject(IdentityRequestService).release(this.data.getUser().id)
            .subscribe({
              next: (res: TakenOverIdentity) => {
                this.data.identityEnd();
                this.data.setUser(this.data.getCurrentUser());
                this.on.takeOver.next(false);
                setTimeout(() => {
                  headerClientService.setAllDataForIdentityAction(res);
                });
                setTimeout(() => this.router.navigate([this.router.url]), 200);
              },
              error: err => {
                console.error('ERROR, while trying to release role/ user');
                console.error(err);
              }
            });
          break;
        }
      }
    });
  }
}
